import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex-shrink-0 border-black/20 border rounded-full overflow-hidden" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 1,
  class: "w-full h-full object-cover",
  src: "/assets/img/avatar-square.jpg",
  alt: "Avatar"
}
const _hoisted_4 = {
  key: 1,
  class: "w-full h-full object-cover",
  src: "/assets/img/avatar-square.jpg",
  alt: "Avatar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NetworkImageComponent = _resolveComponent("NetworkImageComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.campaign.profile.brandLink)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "block w-full h-full",
          href: _ctx.campaign.profile.brandLink,
          target: "_blank"
        }, [
          (_ctx.image)
            ? (_openBlock(), _createBlock(_component_NetworkImageComponent, {
                key: 0,
                class: "w-full h-full object-cover",
                image: _ctx.image,
                width: 300,
                height: 300,
                placeholder: "/assets/img/avatar-square.jpg",
                alt: _ctx.campaign.profile.url
              }, null, 8, ["image", "alt"]))
            : (_openBlock(), _createElementBlock("img", _hoisted_3))
        ], 8, _hoisted_2))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.image)
            ? (_openBlock(), _createBlock(_component_NetworkImageComponent, {
                key: 0,
                class: "w-full h-full object-cover",
                image: _ctx.image,
                width: 300,
                height: 300,
                placeholder: "/assets/img/avatar-square.jpg",
                alt: _ctx.campaign.profile.url
              }, null, 8, ["image", "alt"]))
            : (_openBlock(), _createElementBlock("img", _hoisted_4))
        ], 64))
  ]))
}